export const FETCH_BUNDLE_REPORTING_REQUEST = 'FETCH_BUNDLE_REPORTING_REQUEST';
export const FETCH_BUNDLE_REPORTING_DATA = 'FETCH_BUNDLE_REPORTING_DATA';
export const FETCH_BUNDLE_REPORTING_ERROR = 'FETCH_BUNDLE_REPORTING_ERROR';
export const RESET_REPORT_VIEW_DATA = 'RESET_REPORT_VIEW_DATA';
